export interface LevelConfig {
  /** 棋盘宽度（列数，横向格子数） */
  width: number;
  /** 棋盘高度（行数，纵向格子数） */
  height: number;
  /** 本关使用的方块种类数（受主题包提供的贴图数量上限约束） */
  typeCount: number;
  /** 本关要填充的格子数（偶数，便于两两消完） */
  filled: number;
}

// 移动端适配：棋盘按手机竖屏的比例封顶——窄边（宽/列）与长边（高/行）分别封顶。
// 8×10 是手机竖屏能舒适容纳的最大格局：横向 8 列不至于把格子挤太小，纵向 10 行贴合长屏。
export const WIDTH_MAX = 8; // 宽边（列）上限
export const HEIGHT_MAX = 10; // 长边（行）上限

// 难度曲线（可一行调参）：
//   尺寸：两个方向都从 6 起，每关 +2，宽边封顶 8、长边封顶 10。
//         => 6×6 → 8×8 → 8×10（之后维持 8×10），越往后越接近竖屏满屏。
//   空格：随关卡递减到 0 —— 越往后棋盘越满、越难；最终填满，
//         此时无处可滑，第一步必须点掉一对相邻同类腾出空间。
const START_EMPTY = 12; // 第 1 关的空格数
const EMPTY_STEP = 2; // 每关递减的空格数（保持偶数，使填充数也为偶）

export function levelConfig(level: number, maxKinds: number): LevelConfig {
  const width = Math.min(WIDTH_MAX, 4 + level * 2);
  const height = Math.min(HEIGHT_MAX, 4 + level * 2);
  const total = width * height;
  const typeCount = Math.max(1, Math.min(maxKinds, 6 + level * 4));

  let empty = Math.max(0, START_EMPTY - (level - 1) * EMPTY_STEP);
  if (empty % 2 !== 0) empty--;
  const filled = Math.max(2, Math.min(total, total - empty));

  return { width, height, typeCount, filled };
}
